import { Link } from 'react-router-dom';
import { getToken } from '../../services/tokenStore';

function NotFound() {
    const backPath = getToken() !== null ? '/dashboard' : '/';

    return (
        <main className="content d-flex align-items-center justify-content-center">
            <div className="card card-body border-0 shadow text-center p-5 mx-3">
                <h1 className="h4 mb-1">404</h1>
                <p className="h5 mb-2">Page not found</p>
                <p className="text-gray-600 mb-4">
                    The page you are looking for does not exist or has been
                    moved.
                </p>
                <Link to={backPath} className="btn btn-primary" autoFocus>
                    {backPath === '/dashboard'
                        ? 'Back to Dashboard'
                        : 'Back to Login'}
                </Link>
            </div>
        </main>
    );
}

export default NotFound;
